import styled from '@emotion/styled'
import { useTheme } from '@emotion/react'

import Typography from '@segment/matcha/components/Typography'
import ButtonText from '@segment/matcha/components/ButtonText'
import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import TabsLayoutBase, * as TabsLayout from '@segment/matcha/recipes/TabsLayout'
import useTabs from '@segment/matcha/recipes/Tabs/useTabs'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import data from './data'

const copy = {
  heading: `Explore the product`,
}

const ExploreTheProduct = () => {
  const pageConfig = usePageConfig()
  const { getTrackProps, getControlProps, getPanelProps, activeTabKey } = useTabs(0, data.length, `explore-the-product`)
  const theme = useTheme()

  return (
    <SectionComponent variant="centered">
      <Section.Copy>
        <CopyTextBase centered={true}>
          <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <TabsLayoutBase>
          <TabsLayout.Controls {...getTrackProps()}>
            {data.map((tab, index) => (
              <TabsLayout.Control key={tab.key} {...getControlProps(index)}>
                {tab.title}
              </TabsLayout.Control>
            ))}
          </TabsLayout.Controls>

          {data.map((tab, index) => (
            <TabsLayout.Content {...getPanelProps(index)} active={index === activeTabKey} key={tab.key}>
              <TabsLayout.Copy>
                <Heading variant="h2">{tab.heading}</Heading>

                <List>
                  {tab.list.map((item) => (
                    <ListItem key={item} variant="pMedium" tag="li" tokens={{ color: theme.palette.twilio.gray[80] }}>
                      {item}
                    </ListItem>
                  ))}
                </List>
                <ButtonWrapper>
                  <ButtonText href={getAbsoluteUrl(`/product/${tab.key}/`, pageConfig)} iconEnd={ChevronRightIcon}>
                    Explore {tab.title}
                  </ButtonText>
                </ButtonWrapper>
              </TabsLayout.Copy>

              <TabsLayout.Media>{tab.image}</TabsLayout.Media>
            </TabsLayout.Content>
          ))}
        </TabsLayoutBase>
      </Section.Contents>
    </SectionComponent>
  )
}

const SectionComponent = styled(SectionBase)`
  overflow: hidden;

  ${Section.Wrapper} {
    padding-top: 120px;

    ${({ theme }) => theme.breakpoints.down(`md`)} {
      padding-top: 80px;
    }
  }
`

const Heading = styled(Typography)`
  margin-top: 0;
`

const List = styled.ul`
  display: grid;
  gap: 12px;
  padding-left: 20px;
`

const ListItem = styled(Typography)`
  margin: 0;
`

const ButtonWrapper = styled.div`
  margin-top: 40px;
`

export default ExploreTheProduct
